document.querySelectorAll('.menu-btn').forEach(button => button.addEventListener('click', () => document.querySelector('.main-nav')?.classList.toggle('is-open')));

document.querySelectorAll('.nova-product__quantity').forEach(quantity => {
  const input = quantity.querySelector('input');
  quantity.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { input.value = Math.max(Number(input.min) || 1, (Number(input.value) || 1) - 1); });
  quantity.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { input.value = (Number(input.value) || 1) + 1; });
});

document.querySelectorAll('[data-buy-now]').forEach(button => {
  button.addEventListener('click', () => {
    const form = button.closest('form');
    const variantField = form?.querySelector('[name="id"]');
    const quantityField = form?.querySelector('[name="quantity"]');
    const variantId = String(variantField?.value || '').trim();
    const quantity = Math.max(1, Number.parseInt(quantityField?.value || '1', 10) || 1);

    if (!variantId) return;

    button.disabled = true;
    button.textContent = 'Redirecting…';
    const shopRoot = window.Shopify?.routes?.root || '/';
    window.location.assign(`${shopRoot}cart/${encodeURIComponent(variantId)}:${quantity}?checkout`);
  });
});

(() => {
  const shell = document.querySelector('[data-cart-drawer-shell]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const itemsContainer = document.querySelector('[data-cart-drawer-items]');
  const footer = document.querySelector('[data-cart-drawer-footer]');
  const total = document.querySelector('[data-cart-total]');
  const status = document.querySelector('[data-cart-status]');
  if (!shell || !drawer || !itemsContainer || !footer || !total) return;

  const currency = window.Shopify?.currency?.active || 'GBP';
  const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style: 'currency', currency
  }).format((Number(cents) || 0) / 100);
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const setBusy = busy => {
    drawer.classList.toggle('is-loading', busy);
    drawer.querySelectorAll('button, a').forEach(element => {
      if (element.matches('button')) element.disabled = busy;
    });
  };

  const openDrawer = () => {
    shell.classList.add('is-open');
    shell.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    drawer.focus();
  };

  const closeDrawer = () => {
    shell.classList.remove('is-open');
    shell.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  };

  const updateHeaderCount = count => {
    document.querySelectorAll('.cart-link').forEach(link => {
      let badge = link.querySelector('span');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) badge.remove();
    });
  };

  const renderCart = cart => {
    if (!cart.items.length) {
      itemsContainer.innerHTML = '<div class="cart-drawer__empty"><h3>Your cart is empty</h3><p>Add something you love to get started.</p></div>';
      footer.hidden = true;
    } else {
      itemsContainer.innerHTML = cart.items.map(item => {
        const image = item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" width="90" height="90">` : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__variant">${escapeHtml(item.variant_title)}</p>` : '';
        return `<article class="cart-drawer__item" data-cart-item-key="${escapeHtml(item.key)}">
          <a class="cart-drawer__image" href="${escapeHtml(item.url)}">${image}</a>
          <div class="cart-drawer__info">
            <a class="cart-drawer__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${variant}<p class="cart-drawer__price">${formatMoney(item.final_price)}</p>
            <div class="cart-drawer__controls"><div class="cart-drawer__quantity">
              <button type="button" data-cart-minus aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-plus aria-label="Increase quantity">+</button>
            </div><button class="cart-drawer__remove" type="button" data-cart-remove aria-label="Remove ${escapeHtml(item.product_title)}">Remove</button></div>
          </div><strong class="cart-drawer__line-total">${formatMoney(item.final_line_price)}</strong>
        </article>`;
      }).join('');
      footer.hidden = false;
      total.textContent = `${formatMoney(cart.total_price)} ${currency}`;
    }
    updateHeaderCount(cart.item_count);
  };

  const getCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('The cart could not be loaded.');
    return response.json();
  };

  const changeCart = async (key, quantity) => {
    setBusy(true);
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) throw new Error('The cart could not be updated.');
      renderCart(await response.json());
    } catch (error) {
      status.textContent = error.message;
    } finally { setBusy(false); }
  };

  document.querySelectorAll('[data-cart-drawer-close]').forEach(button => button.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeDrawer(); });

  document.querySelectorAll('.cart-link').forEach(link => link.addEventListener('click', async event => {
    event.preventDefault();
    openDrawer();
    setBusy(true);
    try { renderCart(await getCart()); } catch (error) { status.textContent = error.message; } finally { setBusy(false); }
  }));

  document.querySelectorAll('[data-cart-add]').forEach(button => button.addEventListener('click', async () => {
    const form = button.closest('form');
    if (!form) return;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = button.classList.contains('catalog-add') ? '…' : 'Adding…';
    status.textContent = '';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.description || 'This item could not be added to your cart.');
      }
      renderCart(await getCart());
      openDrawer();
    } catch (error) {
      status.textContent = error.message;
      openDrawer();
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }));

  itemsContainer.addEventListener('click', event => {
    const item = event.target.closest('[data-cart-item-key]');
    if (!item) return;
    const quantity = Number(item.querySelector('.cart-drawer__quantity span')?.textContent) || 1;
    if (event.target.closest('[data-cart-minus]')) changeCart(item.dataset.cartItemKey, Math.max(0, quantity - 1));
    if (event.target.closest('[data-cart-plus]')) changeCart(item.dataset.cartItemKey, quantity + 1);
    if (event.target.closest('[data-cart-remove]')) changeCart(item.dataset.cartItemKey, 0);
  });
})();
